import {Modal} from 'antd';
import {Warning} from 'phosphor-react';
import './styles.less';

const {confirm} = Modal;

interface ConfirmModalProps {
	title: string;
	onSubmit: () => void;
	content?: string;
}

function ConfirmModal({title, onSubmit, content}: ConfirmModalProps) {
	confirm({
		title,
		centered: true,
		className: 'confirm-modal',
		icon: <Warning size={32} weight="fill" />,
		cancelText: 'Չեղարկել',
		okText: 'Հաստատել',
		content,
		onOk() {
			onSubmit && onSubmit();
		},
		width: 700,
		cancelButtonProps: {size: 'large', className: 'main-btn'},
		okButtonProps: {size: 'large', className: 'main-btn'},
		okType: 'ghost'
	});
}

export default ConfirmModal;
